module.exports = __webpack_public_path__ + "static/media/prashanth.602ef853.jpg";